export type AppRoute =
  | { name: 'home' }
  | { name: 'station'; stationId: string }
  | { name: 'place'; placeId: string }
  | { name: 'new-place'; stationId: string | null }
  | { name: 'edit-place'; placeId: string }
  | { name: 'settings' }
  | { name: 'not-found' };

export function parseHash(hash: string): AppRoute {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  const [pathname = '/', query = ''] = raw.split('?');
  const parts = pathname.split('/').filter(Boolean).map((part) => decodeURIComponent(part));

  if (parts.length === 0) return { name: 'home' };
  if (parts.length === 1 && parts[0] === 'settings') return { name: 'settings' };
  if (parts.length === 2 && parts[0] === 'station') return { name: 'station', stationId: parts[1] };
  if (parts.length === 2 && parts[0] === 'place' && parts[1] === 'new') {
    return { name: 'new-place', stationId: new URLSearchParams(query).get('station') };
  }
  if (parts.length === 2 && parts[0] === 'place') return { name: 'place', placeId: parts[1] };
  if (parts.length === 3 && parts[0] === 'place' && parts[2] === 'edit') return { name: 'edit-place', placeId: parts[1] };
  return { name: 'not-found' };
}

export function navigate(hash: string, replace = false): void {
  if (replace) window.location.replace(hash);
  else window.location.hash = hash;
}
